import { URLS } from '../constants'
import { dispatchFetchGet, dispatchFetchPost, dispatchFetchPut, dispatchFetchDelete } from './ActionsUtil'
import {
    SET_NOTIFICATIONS_MODAL,
    GET_ALL_NOTIFICATIONS_BEGIN, GET_ALL_NOTIFICATIONS_SUCCESS, GET_ALL_NOTIFICATIONS_FAILURE,
    POST_NOTIFICATION_BEGIN, POST_NOTIFICATION_SUCCESS, POST_NOTIFICATION_FAILURE,
    PUT_NOTIFICATION_BEGIN, PUT_NOTIFICATION_SUCCESS, PUT_NOTIFICATION_FAILURE,
    DELETE_NOTIFICATION_BEGIN, DELETE_NOTIFICATION_SUCCESS, DELETE_NOTIFICATION_FAILURE
} from '../constants/ActionTypes'

export const acSetNofiticationsModal = payload => ({ type: SET_NOTIFICATIONS_MODAL, payload: payload })

const acGetAllValidNotificationsBegin = () => ({ type: GET_ALL_NOTIFICATIONS_BEGIN })
const acGetAllValidNotificationsSuccess = payload => ({ type: GET_ALL_NOTIFICATIONS_SUCCESS, payload: { response: payload } })
const acGetAllValidNotificationsFailure = err => ({ type: GET_ALL_NOTIFICATIONS_FAILURE, payload: err })

export const acGetAllValidNotifications = () => {
    return dispatchFetchGet(
        `${URLS.NOTIFICATION.ROOT}`,
        acGetAllValidNotificationsBegin,
        acGetAllValidNotificationsSuccess,
        acGetAllValidNotificationsFailure
    )
}

const acPostNotificationBegin = () => ({ type: POST_NOTIFICATION_BEGIN })
const acPostNotificationSuccess = payload => ({ type: POST_NOTIFICATION_SUCCESS, payload: { response: payload } })
const acPostNotificationFailure = err => ({ type: POST_NOTIFICATION_FAILURE, payload: err })

export const acPostNotification = (message, type, valid_until, redirect_url, filter_id) => {

    let body = { message, type, valid_until }
    let body1 = {}, body2 = {}
    if (redirect_url.length !== 0)
        body1 = { redirect_url }
    if (filter_id)
        body2 = { filter_id }

    return dispatchFetchPost(
        `${URLS.NOTIFICATION.ROOT}`,
        {
            ...body,
            ...body1,
            ...body2
        },
        acPostNotificationBegin,
        acPostNotificationSuccess,
        acPostNotificationFailure
    )
}

const acPutNotificationBegin = () => ({ type: PUT_NOTIFICATION_BEGIN })
const acPutNotificationSuccess = payload => ({ type: PUT_NOTIFICATION_SUCCESS, payload: { response: payload } })
const acPutNotificationFailure = err => ({ type: PUT_NOTIFICATION_FAILURE, payload: err })

export const acPutNotification = (id, message, type, valid_until, redirect_url, filter_id) => {

    let body = { message, type, valid_until }
    let body1 = {}, body2 = {}
    if (redirect_url.length !== 0)
        body1 = { redirect_url }
    if (filter_id)
        body2 = { filter_id }

    return dispatchFetchPut(
        `${URLS.NOTIFICATION.ROOT}/${id}`,
        {
            ...body,
            ...body1,
            ...body2
        },
        acPutNotificationBegin,
        acPutNotificationSuccess,
        acPutNotificationFailure
    )
}

const acDeleteNotificationBegin = () => ({ type: DELETE_NOTIFICATION_BEGIN })
const acDeleteNotificationSuccess = payload => ({ type: DELETE_NOTIFICATION_SUCCESS, payload: { response: payload } })
const acDeleteNotificationFailure = err => ({ type: DELETE_NOTIFICATION_FAILURE, payload: err })

export const acDeleteNotification = (id) => {
    return dispatchFetchDelete(
        `${URLS.NOTIFICATION.ROOT}/${id}`,
        acDeleteNotificationBegin,
        acDeleteNotificationSuccess,
        acDeleteNotificationFailure
    )
}